import React, { useEffect } from "react";
import { Redirect, Route ,Outlet,Navigate} from "react-router-dom";
import Layout from "../Common/layout";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

export const ProtectedRoute = ()=>{
  const navigate = useNavigate();

  useEffect(() => {
    axios.interceptors.response.use(
      (res) => {
        if(res?.response?.status == 401){
          navigate('/');
          return false;
        }
        return res;
      },
      (err) => {   
        if(err){
          if(err?.response?.status == 401){
            navigate('/');
            return false;
          }
          return err;
          }
      }
    );
  }, [])

  const isAuthenticated = sessionStorage.getItem("tokenData");
  return (
        isAuthenticated?
            <Layout/>
          :
           <Navigate to='/' />
        
  );
};


export default ProtectedRoute;